import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';

export interface Props {
  className?: string;
  title: string;
  score: number;
}

class OtherScore extends React.Component<Props, any> {
  public render() {
    const { className, score, title } = this.props;

    return (
      <div className={className}>
        <div className="title">{title}</div>
        <div className="score">{score}</div>
      </div>
    );
  }
}

export default styled(OtherScore)`
  padding: 0.75em 1em;

  .score {
    font-size: 1.5em;
    text-align: right;
  }
`;
